import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import * as Constants from 'src/app/models/Constants';
import { LogService } from 'src/app/services/log.service';
declare var $: any;


@Component({
  selector: 'app-database-selector',
  templateUrl: './database-selector.component.html',
  styleUrls: ['./database-selector.component.scss']
})
export class DatabaseSelectorComponent implements OnInit {

  databaseSelectorForm: FormGroup = new FormGroup({});
  public udpDataBaseName: string = "";
  public tbaLifeCycle: string = "";
  public transId: string = "";
  public tempClient: string = "";
  public crrUdpDataBaseName: string = "";
  public crrTbaLifeCycle: string = "";
  public crrTransId: string = "";
  public isTBAClient: boolean = true;
  public isClientSelected = false;
  public isDatabaseSelectorApiFailure = false;
  public listApiFailure = false;
  public errorMessage = Constants.EXTERNAL_API_FAILURE_MSG;
  public disable: boolean = false;
  fileName: string = 'databaseSelectorComponent';

  constructor(
    public rootService: RootScopeService,
    public customerService: CustBusService,
    public dialogRef: MatDialogRef<void>,
    private fb: FormBuilder,
    private apiService: ApiService,
    private logService: LogService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }



  ngOnInit(): void {

    this.disable = false;
    this.databaseSelectorForm = this.fb.group({
      clientId: new FormControl(),
      udpDatabaseName: new FormControl('', Validators.required),
      tbaLifeCycle: new FormControl(),
      transId: new FormControl(),
      clientName: new FormControl(null, [
        Validators.required
      ])
    });
  }

  getTBALifeCycleList() {
    this.apiService.getDataByCommonKeyValueApi(Constants.TBAGUI_LIFECYCLE).subscribe({
      next: (res: any) => {
        if (res && res?.data && res?.data?.body) {
          this.rootService.tbaguiLifeCycleList = res?.data?.body;
          this.rootService.tbaguiLifeCycleAPIFailure = false;
        }
      },
      error: (err) => {
        this.logService.errorLogs("There was a problem loading the data. Try again." + JSON.stringify(err), this.fileName);
        this.rootService.tbaguiLifeCycleAPIFailure = true;
        return null;
      }
    })
  }


  getTBALifecycleName(Id) {

    let name = this.rootService.tbaguiLifeCycleList.find(x => x.fieldValue == Id)?.fieldValueDescription;
    return name
  }

 
  onClientDropDownChange(event) {
    if (event && event?.['value']) {

      this.disable = true;
      console.log(event)
      let selectedClient = event?.['value'];
      if (this.tempClient != selectedClient) {
        this.tempClient = selectedClient;
        // clear field
        this.transId = "";
        this.udpDataBaseName = "";
        this.tbaLifeCycle = "";
        this.crrTransId = "";
        this.crrUdpDataBaseName = "";
        this.crrTbaLifeCycle = "";
        this.isClientSelected = true;
        this.blankDBSelecterValues();
        
      }
      console.log(selectedClient)
      this.udpDataBaseName = this.getMappedValFromClientSystemData("UDP", "TEST-CFG", selectedClient, "COMMON");
      this.tbaLifeCycle = this.getMappedValFromClientSystemData("TBA-GUI", "LIFECYCLE", selectedClient, "COMMON");

      if (this.rootService.dataBaseSelecterMap[this.databaseSelectorForm.value.clientId]) {
        this.crrTbaLifeCycle = this.rootService.dataBaseSelecterMap?.[this.databaseSelectorForm.value.clientId]?.LIFECYCLE;
        this.crrUdpDataBaseName = this.rootService.dataBaseSelecterMap?.[this.databaseSelectorForm.value.clientId]?.['TEST-CFG'];
      } else {
        this.crrTbaLifeCycle = this.tbaLifeCycle;
        this.crrUdpDataBaseName = this.udpDataBaseName;
      }


      if (this.tbaLifeCycle != 'NA' && this.tbaLifeCycle != '' && this.tbaLifeCycle != undefined) {
        this.transId = this.getMappedValFromClientSystemData("TBA-GUI", "TRANS-ID", selectedClient, "COMMON");
        if (this.rootService.dataBaseSelecterMap[this.databaseSelectorForm.value.clientId]) {
          this.crrTransId = this.rootService.dataBaseSelecterMap?.[this.databaseSelectorForm.value.clientId]?.['TRANS-ID'];
        } else {
          this.crrTransId = this.transId;
        }

        this.isTBAClient = true;
        this.databaseSelectorForm.controls['tbaLifeCycle'].setValidators([Validators.required]);
        this.databaseSelectorForm.controls['transId'].setValidators([Validators.required]);
      }
      else {
        this.isTBAClient = false;
        this.tbaLifeCycle = "";
        this.crrTbaLifeCycle = "";
        this.databaseSelectorForm.controls['tbaLifeCycle'].clearValidators();
        this.databaseSelectorForm.controls['transId'].clearValidators();
      }
      this.databaseSelectorForm.controls['tbaLifeCycle'].updateValueAndValidity();
      this.databaseSelectorForm.controls['transId'].updateValueAndValidity();

    }
  }




  /**
   * Closes the database selector dialog if it is open.
   * Utilizes the `dialogRef` to close the dialog.
   */
  closeDatabaseSelector() {
    this.dialogRef?.close();
  }

  submitDbChange() {
    try {
    let payload =
    {
      "userDataBaseMap": {
        [this.databaseSelectorForm.value.clientId]: {
          "LIFECYCLE": this.databaseSelectorForm.value.tbaLifeCycle,
          "TRANS-ID": this.databaseSelectorForm.value.transId,
          "TEST-CFG": this.databaseSelectorForm.value.udpDatabaseName
        }
      }
    }
 
    this.apiService.saveDatabaseSelecter(payload).subscribe({     
      next: (res: any) => {
        console.log(res);
      
        this.rootService.dataBaseSelecterMap[this.databaseSelectorForm.value.clientId] = payload.userDataBaseMap[this.databaseSelectorForm.value.clientId]
        this.crrUdpDataBaseName = this.databaseSelectorForm.value.udpDatabaseName;
        this.crrTbaLifeCycle = this.databaseSelectorForm.value.tbaLifeCycle;
        this.crrTransId = this.databaseSelectorForm.value.transId;        
        this.isDatabaseSelectorApiFailure=false;
        this.blankDBSelecterValues();
      },
      error: (err) => {
        this.isDatabaseSelectorApiFailure=true;
        console.log(err)     
        this.errorMessage = Constants.SAVING_DATA_API_FAILURE_MSG ;
      }
    })
  } catch (error) {
    console.log(error);
  }

  }

  blankDBSelecterValues(){  
    let clientName =this.databaseSelectorForm.value.clientName;    
    $('#dbSelecterForm')[0]?.reset();
    this.databaseSelectorForm.get('clientId')?.setValue(this.tempClient);
    this.databaseSelectorForm.get('clientName')?.setValue(clientName);        
  }

  onClearSelection(clearFlag: boolean): void {
    if (clearFlag) {
      this.blankDBSelecterValues();
      console.log('Clear button was clicked, selection has been cleared.');
    }
  }

  resetToDefault() {
    this.databaseSelectorForm.get('udpDatabaseName')?.setValue(this.udpDataBaseName);
    this.databaseSelectorForm.get('tbaLifeCycle')?.setValue(this.tbaLifeCycle);
    this.databaseSelectorForm.get('transId')?.setValue(this.transId);  
  }

  getMappedValFromClientSystemData(systemName, attributeName, clntId, domainName?) {

    let data = this.rootService.clientSystemIds.find(x => x.clientId == clntId);
    let key = '';
    if (domainName && domainName != 'undefined') {
      key = clntId + "-" + systemName + "-" + domainName + '-' + attributeName;
    }
    else {
      key = clntId + "-" + systemName + "-" + 'COMMON' + '-' + attributeName;
    }
    if (data?.data?.[key]) {
      return data?.data[key]?.targetSystemAttributeValue;
    }
    else
      return 'NA';
  }



}
